// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    addToChainBefore,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import {
    chain,
    DispatchSetInitialValues,
    ValidateShippingAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";

export const xValidateShippingAddress: typeof ValidateShippingAddress = async ({ dispatch, getState, shipTo }) => {
    const state = getState();
    const {
        context: { session },
    } = state;
    if (!shipTo || session.fulfillmentMethod === FulfillmentMethod.PickUp) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const shippingAddressErrors = await awaitableValidate({
        address: shipTo,
        validationRules: shipTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView.value!.shipToAddressFields,
    })(dispatch, getState);
    const isShippingAddressValid = Object.keys(shippingAddressErrors).length === 0;

    // XNG-Changes: CES-595
    dispatch({
        type: "Pages/CheckoutShipping/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: false,
    });
};

export const xPreDispatchSetInitialValues: typeof DispatchSetInitialValues = props => {
    (props as any).editedCartNotes = props.getState().pages.checkoutShipping.editedCartNotes;
};

export const xPostDispatchSetInitialValues: typeof DispatchSetInitialValues = props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/SetNotes",
        notes: (props as any).editedCartNotes,
    });
};

addToChainBefore(chain, DispatchSetInitialValues, xPreDispatchSetInitialValues);
replaceInChain(chain, ValidateShippingAddress, xValidateShippingAddress);
addToChainAfter(chain, DispatchSetInitialValues, xPostDispatchSetInitialValues);
